import clsx from 'clsx';
import { CSSProperties, forwardRef, ReactNode, Ref } from 'react';
import { twMerge } from 'tailwind-merge';

type ReactChildren = ReactNode | ReactNode[] | null;

const Container = ({
  className,
  children,
  containerId,
  fluid = false,
  style,
}: {
  className?: string;
  children?: ReactChildren;
  containerId?: string;
  fluid?: boolean;
  style?: CSSProperties;
}): JSX.Element => {
  return (
    <div
      id={containerId}
      className={twMerge(
        clsx('mx-auto w-full', !fluid && 'xs:w-[540px] sm:w-[720px] md:w-[960px] lg:w-[1140px]', className),
      )}
      style={style}
    >
      {children}
    </div>
  );
};

const Row = ({
  className,
  children,
  style,
}: {
  className?: string;
  children?: ReactChildren;
  style?: CSSProperties;
}): JSX.Element => {
  return (
    <div className={twMerge('flex', className)} style={style}>
      {children}
    </div>
  );
};

// NEED TO FIX COLUMN TO BE ABLE TO USE FLEX PROPERTY WITH BREAKPOINTS
const Col = ({
  className,
  children,
  size = 1,
  style,
}: {
  className?: string;
  children?: ReactChildren;
  size?: number;
  style?: CSSProperties;
}): JSX.Element => {
  return (
    <div
      className={twMerge(clsx('flex-[var(--col-flex-size)]', className))}
      style={{ '--col-flex-size': size, ...style } as CSSProperties}
    >
      {children}
    </div>
  );
};

const Section = forwardRef(
  (
    { className, children, id }: { className?: string; children?: ReactChildren; id?: string },
    ref?: Ref<HTMLDivElement> | null,
  ): JSX.Element => {
    return (
      <section ref={ref} className={twMerge('relative', className)} id={id}>
        {children}
      </section>
    );
  },
);

export { Col, Container, Row, Section };
